import React from 'react';

export const MenuIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="12 6 8 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18 10C18 11.1046 17.1046 12 16 12C14.8954 12 14 11.1046 14 10C14 8.89543 14.8954 8 16 8C17.1046 8 18 8.89543 18 10Z"
      fill="currentColor"
    />
    <path
      d="M18 16C18 17.1046 17.1046 18 16 18C14.8954 18 14 17.1046 14 16C14 14.8954 14.8954 14 16 14C17.1046 14 18 14.8954 18 16Z"
      fill="currentColor"
    />
    <path
      d="M18 22C18 23.1046 17.1046 24 16 24C14.8954 24 14 23.1046 14 22C14 20.8954 14.8954 20 16 20C17.1046 20 18 20.8954 18 22Z"
      fill="currentColor"
    />
  </svg>
);
